export const selectUser = (state) => state.user;

export const selectUserToken = (state) => selectUser(state).token;
